export default function addCustomFooter(doc, margin) {
    const pageCount = doc.internal.getNumberOfPages();
    const printedOn = new Date().toLocaleString([], {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
  
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
  
      const footerLeft = `Printed: ${printedOn}`;
      const footerRight = `Page ${i} of ${pageCount}`;
  
      doc.setFontSize(8);
      doc.setTextColor(100);
  
      doc.text(footerLeft, margin, pageHeight - 20);
      doc.text(
        footerRight,
        pageWidth - margin - doc.getTextWidth(footerRight),
        pageHeight - 20
      );
    }
  }
  